export default __webpack_public_path__ + "static/media/guia-1-4.27b1fd5f.svg";